import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import ProgramsPage from '@/pages/ProgramsPage';
import ProgramDetailPage from '@/pages/ProgramDetailPage';
import ActivitiesPage from '@/pages/ActivitiesPage';
import PartenariatEcolePage from '@/pages/PartenariatEcolePage';
import ContactPage from '@/pages/ContactPage';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import IntranetDashboard from '@/pages/intranet/IntranetDashboard';
import IntranetEleves from '@/pages/intranet/IntranetEleves';
import IntranetSeances from '@/pages/intranet/IntranetSeances';
import IntranetInscriptions from '@/pages/intranet/IntranetInscriptions';
import IntranetRobots from '@/pages/intranet/IntranetRobots';
import IntranetMessages from '@/pages/intranet/IntranetMessages';
import IntranetPresences from '@/pages/intranet/IntranetPresences';
import IntranetObjectifs from '@/pages/intranet/IntranetObjectifs';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/programmes" element={<ProgramsPage />} />
          <Route path="/programmes/:slug" element={<ProgramDetailPage />} />
          <Route path="/partenariat-ecole" element={<PartenariatEcolePage />} />
          <Route path="/activites" element={<ActivitiesPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Auth */}
          <Route path="/login" element={<AdminLoginPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />

          {/* Intranet */}
          <Route path="/intranet" element={<IntranetDashboard />} />
          <Route path="/intranet/eleves" element={<IntranetEleves />} />
          <Route path="/intranet/presences" element={<IntranetPresences />} />
          <Route path="/intranet/seances" element={<IntranetSeances />} />
          <Route path="/intranet/inscriptions" element={<IntranetInscriptions />} />
          <Route path="/intranet/objectifs" element={<IntranetObjectifs />} />
          <Route path="/intranet/robots" element={<IntranetRobots />} />
          <Route path="/intranet/messages" element={<IntranetMessages />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
